import Nullstack from 'nullstack';
export default function IconWifi2({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-wifi-2",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "18",
    x2: "12.01",
    y2: "18"
  }), "   ", Nullstack.element("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), "   ", Nullstack.element("path", {
    d: "M6.343 12.343a8 8 0 0 1 11.314 0"
  }), " ");
}